import { motion } from "framer-motion";
import { CornerDownRight, ChevronsRight } from "lucide-react";
import hero_bg from "../../assets/images/camunda_banner.png";
import { Link } from "react-router-dom";
export default function CamundaBanner() {
  return (
    <>
      <title>About Truviq System</title>
      <section className="relative w-full bg-[#f7f7f5] text-slate-900 overflow-hidden flex items-end pt-36 pb-16 md:pt-44 md:pb-28">
        
        <div
          className="pointer-events-none absolute 
           md:bottom-10 top-20
       right-5 w-[30%] lg:max-w-[25%] h-auto select-none"
        >
          <img
            src={hero_bg}
            alt=""
            className="w-full h-auto object-contain brightness-200 object-right-top"
          />
        </div>

        <div className="mx-auto max-w-7xl px-6 lg:px-12 relative z-10 w-full">
          <div className="max-w-3xl">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-balance text-4xl sm:text-6xl md:text-7xl font-semibold tracking-tight text-slate-950  "
            >
              Camunda
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-lg sm:text-xl text-slate-600 max-w-2xl leading-relaxed"
            >
              Truviq’s Camunda practice covers the full lifecycle — from process
              design and Camunda 8 implementation to complex legacy BPM
              migrations — accelerated by OrchestAI, our proprietary delivery
              engine.
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
              className="mt-6 text-base text-slate-500 flex flex-row gap-1 items-center leading-relaxed"
            >
              <Link to="/">Home</Link> <ChevronsRight size={20} /> About Us
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="mt-7 pt-6 border-t border-slate-300/80 flex items-center gap-3 text-xs font-mono text-slate-500 tracking-widest uppercase"
            >
              <CornerDownRight size={14} className="text-slate-950" />
              <span>Scroll to explore Overview &amp; work</span>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
